module.exports = __webpack_public_path__ + "img/prod-2.589f2e60.png";